import { random } from 'lodash';

const showNewsletterSignup = () => random(1, 25) === 1;

export default showNewsletterSignup;
